var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.49 14.12L19.05 13.47L20.33 11.99L19.04 10.52L18.48 9.87L18.56 9.02L18.74 7.07L16.84 6.64L16 6.45L15.56 5.71001L14.57 4.03001L12.79 4.8L12 5.14L11.2 4.8L9.42 4.03001L8.43 5.71001L7.99 6.45L7.15 6.64L5.25 7.07L5.43 9.01L5.52 9.87L4.96 10.52L3.67 12L4.96 13.47L5.52 14.12L5.44 14.97L5.26 16.93L7.16 17.36L8 17.55L8.44 18.29L9.43 19.96L11.21 19.19L12 18.85L12.8 19.19L14.58 19.96L15.57 18.28L16.01 17.54L16.85 17.35L18.75 16.92L18.57 14.97L18.49 14.12ZM20.56 9.2L23 11.99L20.56 14.79L20.9 18.48L17.29 19.3L15.4 22.49L12 21.03L8.6 22.5L6.71 19.3L3.1 18.48L3.44 14.78L1 11.99L3.44 9.2L3.1 5.5L6.71 4.69L8.6 1.5L12 2.96001L15.4 1.5L17.29 4.69L20.9 5.51L20.56 9.2ZM7.77004 11.42L10.09 13.75L15.95 7.87L17.43 9.35999L10.09 16.72L6.29004 12.91L7.77004 11.42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.49 14.12L19.05 13.47L20.33 11.99L19.04 10.52L18.48 9.87L18.56 9.02L18.74 7.07L16.84 6.64L16 6.45L15.56 5.71001L14.57 4.03001L12.79 4.8L12 5.14L11.2 4.8L9.42 4.03001L8.43 5.71001L7.99 6.45L7.15 6.64L5.25 7.07L5.43 9.01L5.52 9.87L4.96 10.52L3.67 12L4.96 13.47L5.52 14.12L5.44 14.97L5.26 16.93L7.16 17.36L8 17.55L8.44 18.29L9.43 19.96L11.21 19.19L12 18.85L12.8 19.19L14.58 19.96L15.57 18.28L16.01 17.54L16.85 17.35L18.75 16.92L18.57 14.97L18.49 14.12ZM20.56 9.2L23 11.99L20.56 14.79L20.9 18.48L17.29 19.3L15.4 22.49L12 21.03L8.6 22.5L6.71 19.3L3.1 18.48L3.44 14.78L1 11.99L3.44 9.2L3.1 5.5L6.71 4.69L8.6 1.5L12 2.96001L15.4 1.5L17.29 4.69L20.9 5.51L20.56 9.2ZM7.77004 11.42L10.09 13.75L15.95 7.87L17.43 9.35999L10.09 16.72L6.29004 12.91L7.77004 11.42Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationTask);
export default __webpack_public_path__ + "static/media/validation-task.8a2ae633200a7ba9414b4a9d225d7ef1.svg";
export { ForwardRef as ReactComponent };